"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var ItemsCarousel = /*#__PURE__*/function (_window$AbstractView) {
    _inherits(ItemsCarousel, _window$AbstractView);

    var _super = _createSuper(ItemsCarousel);

    _createClass(ItemsCarousel, null, [{
      key: "HORIZONTAL_ASPECT_RATIO",
      get: function get() {
        return "horizontal_aspect_ratio";
      }
    }, {
      key: "SQUARED_ASPECT_RATIO",
      get: function get() {
        return "squared_aspect_ratio";
      }
    }, {
      key: "VERTICAL_ASPECT_RATIO",
      get: function get() {
        return "vertical_aspect_ratio";
      }
    }]);

    function ItemsCarousel(id, options) {
      var _this;

      _classCallCheck(this, ItemsCarousel);

      var OPTIONS_DEFAULT = {
        settings: {
          wrapAround: true
        }
      };
      var OPTIONS_MANDATORY = {
        watchResize: true
      };
      options = $.extend(true, _.clone(options), OPTIONS_DEFAULT);
      options = $.extend(true, OPTIONS_MANDATORY, _.clone(options));
      _this = _super.call(this, id, options);
      if (_this.$domElement.hasClass("multi-aspectratio")) _this.multiAspectRatio = true;
      _this.$carousel = _this.$domElement.find(".carousel").flickity({
        groupCells: true,
        cellAlign: "left",
        prevNextButtons: false,
        pageDots: _this.$domElement.find(".carousel .carousel-cell").length > 1 ? true : false,
        draggable: '>1',
        wrapAround: _this.options.settings.wrapAround
      });
      _this.$cells = _this.$carousel.find(".carousel-cell");
      _this.$pager = _this.$carousel.find(".flickity-page-dots");

      _this.$carousel.on('dragStart.flickity', function (event, pointer) {//this.$cells.css("pointer-events", "none");
      });

      _this.$carousel.on('dragEnd.flickity', function (event, pointer) {//this.$cells.css("pointer-events", "auto");
      });

      return _this;
    }

    _createClass(ItemsCarousel, [{
      key: "resizeHandler",
      value: function resizeHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (this.multiAspectRatio) {
          var GUTTERS = parseInt(this.$cells.css("padding-left")) + parseInt(this.$cells.css("padding-right"));
          var HEIGHT = this.$carousel.find(".flickity-viewport").outerHeight();
          var CELL_INNER_HEIGHT = HEIGHT - GUTTERS;
          this.$cells.each(function (i, el) {
            var cellWidth;
            if ($(el).hasClass("vertical")) cellWidth = CELL_INNER_HEIGHT / 3 * 2;else if ($(el).hasClass("squared")) cellWidth = CELL_INNER_HEIGHT;else cellWidth = CELL_INNER_HEIGHT / 2 * 3;
            $(el).width(cellWidth);
          });
          this.$carousel.flickity("resize");
        } //PAGER


        if (!this.multiAspectRatio && window.Breakpoints.matches(window.Breakpoints.MIN_WIDTH, window.Breakpoints.XL) && this.$cells.length <= 3) {
          this.$carousel.flickity('unbindDrag');
          this.$pager.css("display", "none");
        } else if (!this.multiAspectRatio) {
          this.$carousel.flickity('unbindDrag').flickity('bindDrag');
          this.$pager.css("display", "flex");
        }
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.$carousel.off();
        this.$carousel.flickity("destroy");

        _get(_getPrototypeOf(ItemsCarousel.prototype), "dispose", this).call(this);
      }
    }]);

    return ItemsCarousel;
  }(window.AbstractView);

  window.ItemsCarousel = ItemsCarousel;
})(window);
